(function () {
  const INDIA_STORE = 'tijaluxe.in';
  const GLOBAL_STORE = 'tijaluxe.com';
  const CURRENT_DOMAIN = location.hostname;
  const STORAGE_KEY = 'geo_store_seen_' + CURRENT_DOMAIN;
  const COUNTRY_KEY = 'geo_country';

  // Skip bots
  if (/bot|crawler|spider|crawling/i.test(navigator.userAgent)) return;

  function getUserCountry(cb) {
    const cached = localStorage.getItem(COUNTRY_KEY);
    if (cached) return cb(cached);

    fetch('https://ipapi.co/country/')
      .then(r => r.text())
      .then(code => {
        if (code) {
          localStorage.setItem(COUNTRY_KEY, code);
          cb(code);
        }
      })
      .catch(() => cb(null));
  }

  function openGeoModal(title, text, onConfirm) {
    const modal = document.getElementById('geoModal');
    document.getElementById('geoTitle').innerText = title;
    document.getElementById('geoText').innerText = text;
    document.getElementById('geoGo').onclick = () => {
      modal.style.display = 'none';
      onConfirm && onConfirm();
    };
    modal.style.display = 'flex';
  }

  /* ============================
     SOFT REDIRECT (POPUP)
     ============================ */
  if (!window.SHOPIFY_DESIGN_MODE && !localStorage.getItem(STORAGE_KEY)) {
    getUserCountry(function (country) {
      if (!country) return;

      let target = null;
      let region = '';

      if (country === 'IN' && CURRENT_DOMAIN !== INDIA_STORE) {
        target = INDIA_STORE;
        region = 'India';
      }

      if (country !== 'IN' && CURRENT_DOMAIN !== GLOBAL_STORE) {
        target = GLOBAL_STORE;
        region = 'your region';
      }

      if (!target) return;

      // Mark popup as shown
      localStorage.setItem(STORAGE_KEY, '1');

      setTimeout(() => {
        openGeoModal(
          `Switch to ${region} store?`,
          `For correct pricing and checkout, please use our ${region} store.`,
          () => location.href = 'https://' + target + location.pathname
        );
      }, 1500);
    });
  }

  /* ============================
     HARD REDIRECT (CHECKOUT)
     ============================ */
  function interceptCheckout(e) {
    getUserCountry(function (country) {
      if (!country) return;

      // India users must checkout on .in
      if (country === 'IN' && CURRENT_DOMAIN !== INDIA_STORE) {
        e.preventDefault();
        e.stopImmediatePropagation();

        openGeoModal(
          "Redirecting to India Store",
          "To complete your purchase securely, we're moving you to our India store. Please re-add your items.",
          () => location.href = 'https://' + INDIA_STORE
        );
      }
    });
  }

  function bindCheckoutButtons() {
    const selectors = [
      'button[name="checkout"]',
      'form[action^="/cart"] button[type="submit"]',
      'a[href*="/checkout"]',
      '[data-gokwik-checkout]',
      '.gokwik-checkout'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(btn => {
        btn.addEventListener('click', interceptCheckout, true);
      });
    });
  }

  bindCheckoutButtons();
  document.addEventListener('DOMContentLoaded', bindCheckoutButtons);
})();
